<div class="input-data-container" #rootElement>
  <div class="input-container"
    [ngClass]="{'p-0': !selectedTags || selectedTags?.length === 0}">
    <div *ngFor="let tag of selectedTags;">
      <tag [tagName]="tag.NAME" [backGroundColor]="tag.BACKGROUND_COLOR"
        [foreGroundColor]="tag.FOREGROUND_COLOR" [isSearch]="true"
        [isRemove]="true" (tagRemoved)="onRemove(tag)" [disabled]="disabled"></tag>
    </div>
    <input #inputText type="text"
      class="input-data rbv-field"
      [ngClass]="{'input-data-padding': !selectedTags || selectedTags?.length === 0}"
      [(ngModel)]="inputValue"
      [name]="name"
      [disabled]="disabled"
      [placeholder]="selectedTags?.length > 0 ? '' : placeholder"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (ngModelChange)="valueChanged()"
      (keydown)="onKeydown($event)"
      />
  </div>

  <div *ngIf="isOpen" class="dropdown-items bottom">
    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-icon-small"></div>
    </div>

    <div #container *ngIf="!isLoading" id="DROPDOWN_ITEMS" class="item-container">
      <ng-container *ngIf="tags.length > 0">
        <div class="item" [id]="'ITEMS_' + ci"
           *ngFor="let tag of tags; let ci=index"
           (click)="onTagSelected(tag)">
          <div class="row w-100 align-items-center">
            <div class="col-sm-5">
              <tag [tagName]="tag.NAME" [backGroundColor]="tag.BACKGROUND_COLOR"
              [foreGroundColor]="tag.FOREGROUND_COLOR" [isSearch]="true"
              (tagRemoved)="onRemove(tag)"></tag>
            </div>
            <div class="col-sm-7">{{tag.DESCRIPTION}}</div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="((tags.length === 0) && inputValue?.length > 0)">
        <div class="item no-records-found">
          No Records Found
        </div>
      </ng-container>
    </div>
  </div>
</div>
